<template>
  <form class="filters text-xs-center">
    <v-radio-group v-model="view.elem.radio.value" row dense class="mb-0 pb-0" @change="filter">
      <v-flex xs6 sm3 lg2 xl1 class="py-0">
        <v-radio class="text-xs-center my-0" :label="$t('view.bitacoras.monitorCorreos.form.estatus.options.todos.label')" value="" />
      </v-flex>

      <v-flex xs6 sm3 lg2 xl1 class="py-0">
        <v-radio class="text-xs-center my-0" :label="$t('view.bitacoras.monitorCorreos.form.estatus.options.pendiente.label')" value="pendiente" />
      </v-flex>

      <v-flex xs6 sm3 lg2 xl1 class="py-0">
        <v-radio class="text-xs-center my-0" :label="$t('view.bitacoras.monitorCorreos.form.estatus.options.enviado.label')" value="enviado" />
      </v-flex>

      <v-flex xs6 sm3 lg2 xl1 class="py-0">
        <v-radio class="text-xs-center my-0" :label="$t('view.bitacoras.monitorCorreos.form.estatus.options.error.label')" value="error" />
      </v-flex>
    </v-radio-group>
  </form>
</template>
<script>
export default {
  name: "FiltersModule"
  , props: {
    select: {
      default: null
      , type: Object
    }
  }
  , data() {
    return {
      view: {
        action: { submit: { busy: false } }
        , elem: { radio: { value: "" } }
      }
      , filtros: { estatus: [] }
    };
  }
  , methods: {
    filter() {
      this.filtros.estatus = [];
      if (this.view.elem.radio.value.length > 0) {
        this.filtros.estatus.push(this.view.elem.radio.value);
      }
      this.$emit("filter", this.filtros);
    }
  }
};
</script>

<style scoped>
.filter_button {
  margin-top: 15px;
  width: 35px !important;
  height: 35px !important;
  font-size: 10px !important;
}
.filter_button .v-icon {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bitacoras/monitorCorreos/Filters.vue